angular.module("videos", [])

.directive("youtubeThumbnail", $sce => {
  return {
    restrict: "E",
    replace: true,
    template: '<div class="video-thumbnail" ng-bind-html="videoHtml"></div>',
    scope: {
      key: "@key"
    },
    link: scope => {
      scope.videoHtml = $sce.trustAsHtml('<iframe src="https://www.youtube-nocookie.com/embed/' + scope.key + '?si=-1hKwy-tYYsRRBGi&amp;controls=0&amp;rel=0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>');
    }
  };
});
